import React, { useState } from "react";
import Contacts from "@/pages/contacts";
const Canadavisitvisa = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div>
        <div className="h-98 relative w-full">
          <img
            src="/cannads.jpg" // Replace with the correct path to your image
            alt="Canada Immigration"
            className="h-96 w-full object-cover"
          />
        </div>
      </div>
      <div className="mx-auto mt-10 w-full text-center text-3xl font-bold text-[#011473] drop-shadow-md sm:w-3/4 sm:text-4xl lg:w-1/2 lg:text-5xl xl:ml-96">
        Canada Visit Visa:
      </div>
      <div className="flex flex-col items-center space-y-6 py-20 lg:flex-row lg:space-x-8 lg:space-y-0">
        {/* Left Section: Image */}
        <div className="mb-8 flex justify-center lg:mb-0 lg:w-1/2">
          <img
            src="/visitvisa.jpg" // Replace with the correct path to your image
            alt="Canada Skilled Migration Documents"
            className="w-90 sm:w-90 h-90 rounded object-cover shadow-lg sm:h-96"
          />
        </div>

        {/* Right Section: Text */}
        <div className="space-y-4 sm:space-y-2 lg:w-1/2">
          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Family Sponsorship for Canada Visit Visa
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-10 w-10 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              <a className="text-bold text-black">
                {" "}
                Spouse/Common-Law Partner & Children:
              </a>{" "}
              You can include your spouse/partner and dependent children under
              19 in your visit visa application. Children with disabilities are
              exempt from the age limit.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-10 w-10 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              <a className="text-bold text-black"> Parents/Grandparents:</a>{" "}
              These individuals must be sponsored separately by a permanent
              resident or Canadian citizen. A sponsorship agreement ensures
              financial support and self-sufficiency.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-10 w-10 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              <a className="text-bold text-black"> Other Relatives:</a> Orphaned
              relatives under 19 (e.g., siblings, nephews, nieces,
              grandchildren) can also be sponsored, with similar criteria to
              parents/grandparents. You can also sponsor a child under 19 for
              adoption, provided international adoption rules are followed.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Visit Visa Types
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              <a className="text-bold text-black">Single Entry:</a> Allows one
              entry into Canada during the visa validity.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-10 w-10 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              <a className="text-bold text-black"> Multiple Entry:</a> Permits
              multiple entries into Canada for up to 10 years, with stays of up
              to six months.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              Visa type eligibility is determined based on individual
              circumstances.
            </span>
          </div>
        </div>
      </div>

      <div className="mt-10 w-full px-5 md:mt-10 md:w-full md:px-20 lg:mt-10 xl:mt-10">
        <p className="mb-2 text-center text-3xl font-bold text-[#011473] md:text-4xl">
          Essential Documents for Canada Visit Visa Application
        </p>
        <div className="2xl:px-52 gap-8 mt-20 xl:space-y-0 lg:space-y-0 md:space-y-4 space-y-4 md:grid md:grid-cols-2 md:px-8 lg:grid-cols-3 lg:px-10 xl:grid-cols-3 xl:px-10">
          {[
            {
              href: "#", // Update this if needed
              title: "Completed Application (IMM 5257)",
              description:
                "The main form required for your visitor visa application.",
              imgSrc: "/turist.jpg",
            },
            {
              href: "#", // Update this if needed
              title: "Valid Passport",
              description:
                "Your passport must be valid for your entire stay in Canada with at least one blank page.",
              imgSrc: "/bussines.jpg",
            },
            {
              href: "#", // Update this if needed
              title: "Photographs",
              description:
                "Two recent passport-sized photos that meet the application guidelines.",
              imgSrc: "/visits.JPG",
            },
            {
              href: "#", // Update this if needed
              title: "Financial Proof",
              description:
                "Bank statements, pay stubs, or employment documents showing you can support yourself.",
              imgSrc: "/investor.jpg",
            },
            {
              href: "#", // Update this if needed
              title: "Home Country Ties",
              description:
                "Evidence of reasons to return, such as a job, family, property, or other commitments.",
              imgSrc: "/students.jpg",
            },
            {
              href: "#", // Update this if needed
              title: "Travel Itinerary",
              description:
                "Details of your travel plan, including flight and accommodation information.",
              imgSrc: "/stay.jpg",
            },
            {
              href: "#", // Update this if needed
              title: "Invitation Letter (if applicable)",
              description:
                "If visiting family or friends, an invitation letter from your host in Canada.",
              imgSrc: "/passports.jpg",
            },
            {
              href: "#", // Update this if needed
              title: "Purpose of Visit",
              description:
                "Documents explaining the reason for your trip (tourism, business, family visit, etc.).",
              imgSrc: "/transit.JPG",
            },
            {
              href: "#", // Update this if needed
              title: "Biometrics",
              description:
                "Biometrics (fingerprints and photo) may be required depending on your nationality.",
              imgSrc: "/air.jpg",
            },
            {
              href: "#", // Update this if needed
              title: "Proof of Employment/Study",
              description:
                "A confirmation letter from your employer or educational institution.",
              imgSrc: "/study.jpg",
            },
            {
              href: "#", // Update this if needed
              title: "Fee Payment",
              description: "Proof of payment for the visa application fee.",
              imgSrc: "/fees.jpg",
            },
            {
              href: "#", // Update this if needed
              title: "Additional Documents",
              description:
                "Depending on your case, further documents such as a medical exam or police certificate may be required.",
              imgSrc: "/documents.jpg",
            },
          ].map((resource, index) => (
            <div
              key={index}
              data-aos="fade-up"
              className="group relative flex w-full flex-col overflow-hidden rounded-3xl border border-black font-sans transition-shadow duration-300 hover:shadow-lg"
            >
              <a href={resource.href} className="block flex-1">
                <div className="relative h-[200px] w-full overflow-hidden rounded-2xl">
                  <img
                    src={resource.imgSrc}
                    alt={resource.title}
                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <div className="flex-1 px-6 py-6">
                  <h3 className="font-syne mb-2 text-xl font-medium text-[#011473]">
                    {resource.title}
                  </h3>
                  <p className="text-sm font-medium text-black">
                    {resource.description}
                  </p>
                </div>
              </a>
            </div>
          ))}
        </div>

        <div className="container mx-auto mb-10 mt-14">
          <h2 className="text-center text-3xl font-semibold text-[#011473]">
            Canada Tourist Visa Requirements
          </h2>
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
            <div className="flex items-center justify-center">
              <img
                src="/turist.jpg"
                alt="Canada Tourist"
                className="w-full rounded-xl object-cover"
              />
            </div>
            <div className="flex flex-col justify-center text-left text-black">
              <p className="mt-4 text-lg">
                To apply for a Canada tourist visa, applicants must meet the
                following requirements:
              </p>
              <ul className="mt-4 list-disc pl-6">
                <li>
                  <strong>Passport</strong>: Valid for 6 months beyond travel
                  date.
                </li>
                <li>
                  <strong>Emirates ID</strong>: Valid copy required.
                </li>
                <li>
                  <strong>Photos</strong>: 2 passport-sized, white background,
                  matte finish.
                </li>
                <li>
                  <strong>Financial Proof</strong>: Bank statements showing
                  funds for travel.
                </li>
                <li>
                  <strong>Visa Fee</strong>: Non-refundable fee payment.
                </li>
                <li>
                  <strong>NOC</strong>: Employer certificate with salary, role,
                  and purpose.
                </li>
                <li>
                  <strong>Business Visa</strong>: Proof of income, trade license
                  and partner details.
                </li>
                <li>
                  <strong>Travel Insurance</strong>: Coverage for the entire
                  stay.
                </li>
                <li>
                  <strong>Purpose Letter</strong>: Explanation of visit purpose
                  (business or training).
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="container mx-auto mb-10 mt-14">
          <h2 className="text-center text-3xl font-semibold text-[#011473]">
            Business Visa
          </h2>
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
            <div className="flex flex-col justify-center text-left text-black">
              <p className="mt-4 text-lg">
                For those seeking to visit Canada for business purposes, the
                following points are essential:
              </p>
              <ul className="mt-4 list-disc pl-6">
                <li>
                  <strong>Business Visitor Visa</strong>: Required for
                  short-term business activities like meetings or conferences,
                  unless exempt.
                </li>
                <li>
                  <strong>Business Visa vs. Work Permit</strong>: Business visa
                  is for meetings, not work. Apply for a work permit if needed.
                </li>
                <li>
                  <strong>TRV Application</strong>: Apply through the Canadian
                  visa office in your country of residence.
                </li>
                <li>
                  <strong>Visa Exemption</strong>: Some visa-exempt visitors may
                  need an eTA if arriving by air.
                </li>
                <li>
                  <strong>Family Members</strong>: Family can accompany business
                  visitors, with separate visa applications.
                </li>
                <li>
                  <strong>Proof of Purpose</strong>: You may need to provide
                  business documents upon entry to Canada.
                </li>
              </ul>
            </div>

            <div className="flex items-center justify-center">
              <img
                src="/bussines.jpg"
                alt="Canada Business Visa"
                className="w-full rounded-xl object-cover"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="mb-20 p-4 md:ml-32">
        <p className="mb-5 text-left text-2xl font-bold text-[#011473] md:text-3xl lg:text-4xl">
          Visa World Immigration Services:
        </p>
        <div className="space-y-4 md:space-y-6">
          <div className="flex items-center justify-start md:justify-start">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 text-sm font-medium text-gray-700 md:text-base lg:text-lg">
              Comprehensive support with visa application form completion and
              submission.
            </span>
          </div>

          <div className="flex items-center justify-start md:justify-start">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 text-sm font-medium text-gray-700 md:text-base lg:text-lg">
              Document verification and handling of submission at the
              embassy/VAC.
            </span>
          </div>

          <div className="flex items-center justify-start md:justify-start">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 text-sm font-medium text-gray-700 md:text-base lg:text-lg">
              Seamless assistance with booking appointments for Canadian visas.
            </span>
          </div>

          <div className="flex items-center justify-start md:justify-start">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 text-sm font-medium text-gray-700 md:text-base lg:text-lg">
              Tailored holiday packages with expert guidance, including airport
              transfers.
            </span>
          </div>

          <div className="flex items-center justify-start md:justify-start">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 text-sm font-medium text-gray-700 md:text-base lg:text-lg">
              Step-by-step assistance throughout the entire visa process.
            </span>
          </div>
        </div>
      </div>

      <Contacts />
    </>
  );
};

export default Canadavisitvisa;
